module.exports = __webpack_public_path__ + "static/bigLogo-ab9d49665117dc52b5117e9a5b488895.png";